export default "__VITE_ASSET__Bb19MnNQ__"